<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <p class="test-start font-weight-bold text-primary">روزهای تعطیل</p>
        <p class="text-small text-grey-darken-1 mb-3 mt-1 mb-5">به صورت پیش‌فرض تمام روزهای سال به عنوان روزهای کاری در محاسبات قوانین SLA مورد استفاده قرار می‌گیرند.<br> چنانچه تمایل دارید روزهایی را به عنوان روزهای تعطیل مجموعه خود از این محاسبات خارج نمایید آن‌ روزها را در تقویم زیر انتخاب کنید.</p>
        <v-row align="center" >
            <v-col md="auto" cols="12">
                <v-date-picker
                    color="secondary"
                    show-adjacent-months
                    multiple
                    hide-header
                    v-model="dates"
                ></v-date-picker>
            </v-col>
            <v-divider vertical inset class="d-none d-md-block"></v-divider>
            <v-col cols="12" md>
                <div class="overflow-y-auto" style="height: 400px; scrollbar-width:thin">
                    <div v-for="(key,index0) in Object.keys(calcOffdays)" :key="index0">
                        <div class="d-flex align-center text-secondary text-meta mt-3 font-weight-bold"><span class="bg-white px-2">{{key}}</span><v-divider color="secondary"></v-divider></div>
                        <v-row class="mt-1 mx-0">
                            <v-col v-for="(item,index) in calcOffdays[key]" :key="index"  cols="auto">
                                <div class="px-3 py-1 rounded text-meta text-grey-darken-2 user-select-none" style="background-color:#F5F5F5">
                                    <v-icon @click="()=>{offdays.splice(offdays.findIndex(x=>x==item),1)}" class="rounded-circle me-1 cursor-pointer" color="grey-darken-2" size="15" style="padding:1px;margin-bottom:2px;background-color:#CCCCCC">clear</v-icon>
                                    <span class="user-select-none">{{ item }}</span>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>
        <div class="mt-8">
            <v-btn @click="sendoffdays" color="success" :loading="loading">ثبت اطلاعات</v-btn>
            <v-btn @click="router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
        </div>
    </div>
</template>

<script setup>
defineOptions({
    title: "روزهای تعطیل",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.workingshift;
    },
});

const router = useRouter();
const api = useApi();
const toast = useToastStore();
const moment = useMoment();
const system = useSystemStore();
const loading = ref(false);
const offdays = ref([...system.settings.offdays]);
const calcOffdays = computed(() =>  {
    let offdayValues = [...offdays.value];
    offdayValues.sort();
    let res = {};
    offdayValues.forEach(el => {
        let parsedDate = moment(el, 'X');
        if(!res[parsedDate.format('jMMMM')])
            res[parsedDate.format('jMMMM')] = [];
        res[parsedDate.format('jMMMM')].push(parsedDate.format('jYYYY/jMM/jDD'));
    });
    return res;
})
const dates = computed({
    get: () => offdays.value.map(x => moment(x, 'X')),
    set: (value) => offdays.value = value.map(x => x.format('X'))
})

function sendoffdays() {
    loading.value = true;
    api.updateSettings({ offdays: offdays.value, _method: 'put'}).then(res => {
        if (res && res.status == "UPDATED") {
            toast.success(res.message);
            system.setGlobalSettings(true);
        }
    }).finally(()=>{loading.value = false});
}
</script>
